module.exports = __webpack_public_path__ + "static/logo.codeuntapped-998c98b804fa5b4a541ea79458f8bc11.svg";